import type { V1GetAvailableAddOnsRequest } from '@ennismore/booking-api-client';
import { useQuery } from 'react-query';

import { useEnnismoreApiClientConfig } from '@/api';
import { MissingAPIDialectError } from '@/api/errors';
import { getBookingServiceClient } from '@/booking/services/client';
import {
  selectHotelConfigurationByReferenceIdOrFail,
  useActiveBrandConfig,
} from '@/brand';
import { mapNetworkError } from '@/errors';

import { AddOnError } from '../errors';
import { useSessionId } from '@/session/use-session-id.hook';

export const useAvailableAddOns = (
  args: V1GetAvailableAddOnsRequest & { locale: { language: string } }
) => {
  const brandConfig = useActiveBrandConfig();
  const sessionId = useSessionId();
  const clientConfig = useEnnismoreApiClientConfig();

  const { dialect } = selectHotelConfigurationByReferenceIdOrFail(
    brandConfig,
    args.hotelReferenceId
  );

  if (!dialect) {
    throw new MissingAPIDialectError();
  }

  return useQuery(['availableAddOns', args], async () => {
    try {
      return await getBookingServiceClient(
        clientConfig,
        dialect
      ).getAvailableAddOns({ ...args, sessionId });
    } catch (e) {
      console.error(e);
      throw new AddOnError(await mapNetworkError(e));
    }
  });
};
